var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77355 4C4.79402 4 4 4.76997 4 5.71921V26.2808C4 27.2303 4.79402 28 5.77355 28H26.2264C27.2059 28 28 27.2303 28 26.2808V5.71921C28 4.76997 27.2059 4 26.2264 4H5.77355ZM11.2533 24.078V13.2053H7.63941V24.078H11.2533ZM9.44634 11.7208C10.7066 11.7208 11.491 10.8859 11.491 9.84248C11.4675 8.7756 10.7066 7.96387 9.47025 7.96387C8.23405 7.96387 7.42578 8.7756 7.42578 9.84248C7.42578 10.8859 8.21001 11.7208 9.42278 11.7208H9.44627H9.44634ZM13.2527 24.078H16.8665V18.0062C16.8665 17.6812 16.8899 17.3566 16.9854 17.1243C17.2466 16.475 17.8413 15.8026 18.8396 15.8026C20.1473 15.8026 20.6704 16.7997 20.6704 18.2613V24.078H24.284V17.8437C24.284 14.5041 22.5011 12.9501 20.1234 12.9501C18.2064 12.9501 17.3468 14.0038 16.8666 14.7446V13.2053H13.2527C13.3001 14.2255 13.2527 24.078 13.2527 24.078ZM16.8666 14.7446V14.7821H16.8424L16.8666 14.7446Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8ae8aea33927d4fc0f1f65049c66c5fa.svg";
export { ForwardRef as ReactComponent };